/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'avatar': {
    width: 32,
    height: 32,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M912.633 917.332c0 22.47-17.892 40.7-39.914 40.7-22.058 0-39.913-18.23-39.913-40.7l-.075-.49h-1.088C812.697 759.175 683.465 636.544 524.82 631.366c-3.413.151-6.752.562-10.24.562-3.45 0-6.79-.41-10.203-.525-158.606 5.14-287.84 127.807-306.784 285.437h-1.014l.076.49c0 22.47-17.855 40.7-39.913 40.7s-39.915-18.23-39.915-40.7l-.374-3.789c0-6.751 2.026-12.904 4.915-18.53C142.45 754.297 232.445 636.769 356.8 582.225c-73.714-51.393-122.144-137.71-122.144-235.621 0-157.591 125.334-285.361 279.925-285.361 154.628 0 279.96 127.77 279.96 285.361 0 97.873-48.391 184.153-122.104 235.546 124.843 54.732 215.1 172.863 235.809 314.211 2.437 5.29 4.014 10.992 4.014 17.181l.373 3.79zM714.49 346.68c0-112.577-89.545-203.81-199.984-203.81-110.402 0-199.945 91.234-199.945 203.81s89.543 203.809 199.945 203.809c110.44 0 199.984-91.232 199.984-203.81z" _fill="#2e3c50"/>'
  }
})
